import { defineComponent } from "vue";
import popupBanner from "../../../../img/FINAL_AXXESSCLIEN_AGILE_2026.png";
import popupBanner2 from "../../../../img/Takeover_02.png";
import popupBanner3 from "../../../../img/Takeover_03.png";
import popupBanner4 from "../../../../img/Takeover_04.png";
import popupBanner5 from "../../../../img/Takeover_05.png";

const bannerKey = "windowpopup_index"
export default defineComponent({
    data() {
        return {
            banners:[
                popupBanner,
                popupBanner2,
                popupBanner3,
                popupBanner4,
                popupBanner5
            ],
            banner: null,
            isVisible: false,
            redirectUrl: "https://www.axxess.com/AGILE",
            bannerExpiry: new Date("2021-05-04"),
            blackIcon: false
        };
    },

    created() {
        if(new Date() >= this.bannerExpiry) return;

        const today = new Date().toISOString().split("T")[0];
        const lastShow = localStorage.getItem("windowpopnotify");
        if(today === lastShow) return;

        const counter = Number(localStorage.getItem(bannerKey) ?? 0);
        const bannerIndex =  counter === this.banners.length-1 ? 0 : counter + 1;
        this.banner = this.banners[bannerIndex];
        this.blackIcon = bannerIndex === 3 || bannerIndex === 4;
        this.isVisible = true;
        localStorage.setItem(bannerKey, String(bannerIndex))
    },

    methods: {
        closeBannerPopup() {
            this.isVisible = false;
            localStorage.setItem("windowpopnotify", new Date().toISOString().split("T")[0]);
        }
    }
});
